"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));
var _DraggableRightList = _interopRequireDefault(require("./DraggableRightList"));
var _reactWindow = require("react-window");
var _runtime = require("@preact/signals-react/runtime");
var _signalsReact = require("@preact/signals-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      margin: "auto"
    },
    paper: {
      width: "100%",
      height: 500,
      overflow: "auto"
    },
    button: {
      margin: theme.spacing(0.5, 0.5)
    },
    rootPaperLeft: {
      paddingLeft: "0px !important"
    },
    rootPaperRight: {
      paddingRight: "8px !important"
    },
    label: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    listItemText: {
      "& span": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    },
    gridEmpty: {
      width: "100%",
      marginTop: theme.spacing(1),
      overflow: "hidden"
    },
    draggableItem: {
      cursor: "grab",
      "&:active": {
        cursor: "grabbing"
      }
    },
    draggingOver: {
      backgroundColor: theme.palette.action.hover,
      borderTop: "2px solid ".concat(theme.palette.primary.main)
    },
    dragHandle: {
      display: "flex",
      alignItems: "center",
      marginRight: theme.spacing(1),
      color: theme.palette.text.secondary,
      cursor: "grab",
      userSelect: "none",
      "&:active": {
        cursor: "grabbing"
      }
    },
    dragging: {
      opacity: 0.4
    }
  };
});
function not(a, b, getItemIdentifier) {
  return a.filter(function (value) {
    return !b.find(function (vb) {
      var getId = getItemIdentifier || function (item) {
        return item.id;
      };
      return getId(vb) === getId(value);
    });
  });
}
function applyFilterLeft(allItens, selectedItens, getItemIdentifier) {
  return not(allItens, selectedItens, getItemIdentifier);
}
var RowLeft = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var data = _ref.data,
    index = _ref.index,
    style = _ref.style;
  var classes = useStyles();
  var items = data.items,
    getItemIdentifier = data.getItemIdentifier,
    getItemText = data.getItemText,
    checkedLeft = data.checkedLeft;
  var item = items[index];
  item.checked = !!item.checked;
  var labelId = "".concat(getItemIdentifier(item));
  var handleToggle = function handleToggle() {
    item.checked = !item.checked;
    checkedLeft.value += item.checked ? 1 : -1;
  };
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    key: index,
    button: true,
    onClick: handleToggle,
    style: style,
    disableRipple: true,
    disabled: item.disabled
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    size: "small",
    checked: item.checked,
    tabIndex: -1,
    disableRipple: true,
    inputProps: {
      "aria-labelledby": labelId
    }
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    size: "small",
    id: labelId,
    primary: getItemText(item),
    className: classes.listItemText
  }));
}, _reactWindow.areEqual);
var SttOrderableDoubleList = function SttOrderableDoubleList(_ref2) {
  var allItens = _ref2.allItens,
    selectedItens = _ref2.selectedItens,
    onChange = _ref2.onChange,
    getItemText = _ref2.getItemText,
    getItemIdentifier = _ref2.getItemIdentifier,
    labelLeft = _ref2.labelLeft,
    labelRight = _ref2.labelRight,
    reset = _ref2.reset,
    callbackReset = _ref2.callbackReset;
  (0, _runtime.useSignals)();
  var classes = useStyles();
  var checkedLeft = (0, _runtime.useSignal)(0);
  var checkedRight = (0, _runtime.useSignal)(0);
  var left = (0, _runtime.useSignal)(applyFilterLeft(allItens, selectedItens, getItemIdentifier));
  var right = (0, _runtime.useSignal)(selectedItens);
  var sortList = function sortList(a, b) {
    var normalizeText = function normalizeText(text) {
      return text.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    };
    return normalizeText(getItemText(a)).localeCompare(normalizeText(getItemText(b)));
  };
  var handleAllRight = function handleAllRight() {
    var disabled = left.value.filter(function (l) {
      return l.disabled;
    });
    var notDisabled = left.value.filter(function (l) {
      return !l.disabled;
    });
    var newRight = right.value.concat(notDisabled);
    newRight.forEach(function (el) {
      el.checked = false;
    });
    (0, _signalsReact.batch)(function () {
      right.value = newRight;
      left.value = disabled;
      checkedRight.value = 0;
      checkedLeft.value = 0;
    });
  };
  var handleCheckedRight = function handleCheckedRight() {
    var selected = left.value.filter(function (l) {
      return l.checked;
    });
    var notSelected = left.value.filter(function (l) {
      return !l.checked;
    });
    var newRight = right.value.concat(selected);
    newRight.forEach(function (el) {
      el.checked = false;
    });
    (0, _signalsReact.batch)(function () {
      right.value = newRight;
      left.value = notSelected.sort(sortList);
      checkedRight.value = 0;
      checkedLeft.value = 0;
    });
  };
  var handleCheckedLeft = function handleCheckedLeft() {
    var selected = right.value.filter(function (l) {
      return l.checked;
    });
    var notSelected = right.value.filter(function (l) {
      return !l.checked;
    });
    var newLeft = left.value.concat(selected);
    newLeft.forEach(function (el) {
      el.checked = false;
    });
    (0, _signalsReact.batch)(function () {
      left.value = newLeft.sort(sortList);
      right.value = notSelected;
      checkedRight.value = 0;
      checkedLeft.value = 0;
    });
  };
  var handleAllLeft = function handleAllLeft() {
    var disabled = right.value.filter(function (r) {
      return r.disabled;
    });
    var notDisabled = right.value.filter(function (r) {
      return !r.disabled;
    });
    var newLeft = left.value.concat(notDisabled);
    newLeft.forEach(function (el) {
      el.checked = false;
    });
    (0, _signalsReact.batch)(function () {
      left.value = newLeft.sort(sortList);
      right.value = disabled;
      checkedRight.value = 0;
      checkedLeft.value = 0;
    });
  };
  var handleReorder = (0, _react.useCallback)(function (fromIndex, toIndex) {
    var next = _toConsumableArray(right.value);
    var _next$splice = next.splice(fromIndex, 1),
      _next$splice2 = _slicedToArray(_next$splice, 1),
      moved = _next$splice2[0];
    next.splice(toIndex, 0, moved);
    right.value = next;
  }, []);
  (0, _react.useEffect)(function () {
    (0, _signalsReact.batch)(function () {
      left.value = applyFilterLeft(allItens, selectedItens, getItemIdentifier);
      right.value = selectedItens;
    });
  }, [allItens, selectedItens]);
  (0, _react.useEffect)(function () {
    if (reset) {
      (0, _signalsReact.batch)(function () {
        checkedRight.value = 0;
        checkedLeft.value = 0;
        right.value = selectedItens.map(function (el) {
          return _objectSpread(_objectSpread({}, el), {}, {
            checked: false
          });
        });
        left.value = applyFilterLeft(allItens, selectedItens, getItemIdentifier).map(function (el) {
          return _objectSpread(_objectSpread({}, el), {}, {
            checked: false
          });
        });
      });
      callbackReset && callbackReset();
    }
  }, [reset]);
  (0, _react.useEffect)(function () {
    onChange && onChange(right.value);
  }, [right.value]);
  var createLeftItemData = function createLeftItemData(items) {
    return {
      items: items,
      getItemIdentifier: getItemIdentifier,
      getItemText: getItemText,
      classes: classes,
      checkedLeft: checkedLeft
    };
  };
  var leftList = function leftList(items) {
    var itemData = createLeftItemData(items);
    return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
      className: classes.paper
    }, items.length > 0 ? /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
      height: 500,
      itemCount: items.length,
      itemData: itemData,
      itemSize: 35,
      width: "100%"
    }, RowLeft) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: 1,
      alignItems: "center",
      justifyContent: "center",
      className: classes.gridEmpty
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      component: "legend",
      className: classes.label
    }, "Nenhum item dispon\xEDvel")));
  };
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 1,
    alignItems: "center",
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: true,
    className: classes.rootPaperLeft
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend",
    className: classes.label
  }, labelLeft), leftList(left.value)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: 1
  }, /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllRight,
    disabled: left.value.length === 0,
    "aria-label": "Mover tudo para \xE0 direita"
  }, "\u226B"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedRight,
    disabled: checkedLeft.value === 0,
    "aria-label": "Mover selecionados para \xE0 direita"
  }, ">"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedLeft,
    disabled: checkedRight.value === 0,
    "aria-label": "Mover selecionados para \xE0 esquerda"
  }, "<"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllLeft,
    disabled: right.value.length === 0,
    "aria-label": "Mover tudo para \xE0 esquerda"
  }, "\u226A"))), /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    mdUp: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "row",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllRight,
    disabled: left.value.length === 0,
    "aria-label": "Mover tudo para baixo"
  }, "\u21A1"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedRight,
    disabled: checkedLeft.value === 0,
    "aria-label": "Mover selecionados para baixo"
  }, "\u2193"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedLeft,
    disabled: checkedRight.value === 0,
    "aria-label": "Mover selecionados para cima"
  }, "\u2191"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllLeft,
    disabled: right.value.length === 0,
    "aria-label": "Mover tudo para cima"
  }, "\u219F")))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: true,
    className: classes.rootPaperRight
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend",
    className: classes.label
  }, labelRight), /*#__PURE__*/_react["default"].createElement(_DraggableRightList["default"], {
    items: right.value,
    getItemIdentifier: getItemIdentifier,
    getItemText: getItemText,
    setChecked: function setChecked(fn) {
      checkedRight.value = fn(checkedRight.value);
    },
    onReorder: handleReorder,
    emptyText: "Nenhum item adicionado"
  })));
};
SttOrderableDoubleList.propTypes = {
  selectedItens: _propTypes["default"].arrayOf(_propTypes["default"].object),
  allItens: _propTypes["default"].arrayOf(_propTypes["default"].object),
  getItemIdentifier: _propTypes["default"].func.isRequired,
  getItemText: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func,
  callbackReset: _propTypes["default"].func,
  reset: _propTypes["default"].bool,
  labelLeft: _propTypes["default"].string,
  labelRight: _propTypes["default"].string
};
SttOrderableDoubleList.defaultProps = {
  selectedItens: [],
  allItens: [],
  reset: false
};
var _default = SttOrderableDoubleList;
exports["default"] = _default;